import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { getGroup, listGroups } from '../../../types'
import { actionApiCall } from '../api/actionApiCall'

export const groupsQueryKey = ['groups'] as const
export const groupQueryKey = (groupId: string) => ['groups', groupId] as const

export function useGroups(includeArchived = false) {
    return useQuery({
        queryKey: [...groupsQueryKey, { includeArchived }],
        queryFn: () => actionApiCall(() => listGroups({ query: { includeArchived } })),
    })
}

export function useGroup(groupId: string) {
    return useQuery({
        queryKey: groupQueryKey(groupId),
        queryFn: () => actionApiCall(() => getGroup({ path: { groupId } })),
        enabled: !!groupId,
    })
}

/** Zneplatní cache skupiny i jejího seznamu po zápisu. */
export function useInvalidateGroups() {
    const queryClient = useQueryClient()

    return useCallback(
        async (groupId?: string) => {
            await queryClient.invalidateQueries({ queryKey: groupsQueryKey })
            if (groupId) {
                await queryClient.invalidateQueries({ queryKey: groupQueryKey(groupId) })
            }
        },
        [queryClient],
    )
}
